import { styled } from "@mui/material/styles";

export const WrapperSearchByOr = styled("div")({
  paddingBottom: 24,
})
